import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { QueryResultSettingsProxy } from '@msdyn365-commerce-modules/retail-actions';
import { IActionContext } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

export type ProductAttributesMap = Map<number, AttributeValue[]>;

export interface IProductCatalogPair {
    productId: number;
    catalogId: number;
}

const loadAttributesForSingleCatalog = async (
    productIds: number[],
    catalogId: number,
    channelId: number,
    actionContext: IActionContext
): Promise<ProductAttributesMap> => {
    const qrs = QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(actionContext);
    const map: ProductAttributesMap = new Map();

    await Promise.all(
        productIds.map(async id => {
            try {
                const attrs = await getAttributeValuesAsync(
                    { callerContext: actionContext, queryResultSettings: qrs },
                    id,
                    channelId,
                    catalogId
                );
                map.set(id, attrs);
            } catch {
                map.set(id, []);
            }
        })
    );

    return map;
};

export const loadAttributesForProducts = async (
    pairs: IProductCatalogPair[],
    channelId: number,
    actionContext: IActionContext
): Promise<ProductAttributesMap> => {
    const byCatalog = new Map<number, number[]>();
    pairs.forEach(({ productId, catalogId }) => {
        if (!byCatalog.has(catalogId)) {
            byCatalog.set(catalogId, []);
        }
        byCatalog.get(catalogId)!.push(productId);
    });

    const result: ProductAttributesMap = new Map();

    for (const [catalogId, ids] of byCatalog) {
        const chunk = await loadAttributesForSingleCatalog(ids, catalogId, channelId, actionContext);
        chunk.forEach((attrs, id) => result.set(id, attrs));
    }

    return result;
};
